import React from 'react';
import { FieldRenderProps } from 'react-final-form';

import { Box, TextField } from '@mui/material';

import { getFieldError } from '@core/FinalForm/getFieldError';
import InputLabel from '@components/common/InputLabel';

export const RenderNameField: React.FC<FieldRenderProps<string>> = ({
  input,
  meta,
}) => {
  return (
    <Box my={1}>
      <InputLabel label={'Title'} />
      <TextField
        inputProps={{
          'data-testid': `story-chat-edit-name`,
        }}
        required
        fullWidth
        placeholder={'Enter your title'}
        error={!!getFieldError(meta)}
        helperText={getFieldError(meta)}
        {...input}
      />
    </Box>
  );
};
